import {
    FETCH_SEMESTER_REQUEST,
    FETCH_SEMESTER_SUCCESS,
    FETCH_SEMESTER_FAILURE,
    SET_CURRENT_SEMESTER,
    CLEAR_SEMESTER
} from '../actions/types';

const initialState = {
    currentSemester: null,
    loading: false,
    error: null,
    lastFetched: null
};

const semesterReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SEMESTER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_SEMESTER_SUCCESS:
            return {
                ...state,
                currentSemester: action.payload,
                loading: false,
                error: null,
                lastFetched: new Date().toISOString()
            };

        case FETCH_SEMESTER_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                currentSemester: null
            };

        case SET_CURRENT_SEMESTER:
            return {
                ...state,
                currentSemester: action.payload
            };

        case CLEAR_SEMESTER:
            return initialState;

        default:
            return state;
    }
};

export default semesterReducer;
